import { CourseStatus } from '../../../../../api/types/programs/course/course-status';
import { toast } from 'react-toastify';
import appApi from '../../../../../api/app-api';
import globalCourseStore from '../../../../../stores/global-course-store';
import globalProgramStore from '../../../../../stores/program-store';
import { runInAction } from 'mobx';
import { CourseMetadataType } from '../../../../../api/types/programs/course/course-metadata.type';

export const updateCourseStatusOperations = async (
  programId: number,
  courseId: number,
  programYear: number | undefined,
  status: CourseStatus,
  render?: () => any,
) => {
  const toastId = toast.loading('');
  try {
    const res = await appApi.updateCourseStatus(programId, courseId, status);
    const currentCourse = globalCourseStore.getCurrentCourse();

    const currentProgramId = globalProgramStore.getCurrentId();
    const currentProgram = globalProgramStore.programs.get(currentProgramId);
    if (currentProgram && programYear !== undefined) {
      runInAction(() => {
        const currentCourse = currentProgram?.details?.years[
          programYear
        ].courses.find((item) => item.id === courseId);
        currentCourse!.status = status;
        render && render();
      });
    }

    const course = globalCourseStore.getCurrentCourse();
    if (course) {
      course!.metadata.status = status;
    }
    toast.dismiss(toastId);
    toast.success(`סטטוס הקורס שונה בהצלחה`);
  } catch (e) {
    toast.dismiss(toastId);
    toast.error(`עדכון סטטוס הקורס נכשל, נסה שוב בעוד מספר רגעים`);
    console.error(
      `Update course ${courseId} with the status: ${status} is failed with the error: ${e}`,
    );
  }
};
